export default "__VITE_ASSET__Lv1LmAc3__"